/**
 * Coexistence plan response
 */
export interface ICoexistencePlanResponse {
	/**
	 * IMV boolean
	 */
	imv: boolean;

	/**
	 * URL
	 */
	url: string;
}
